import CommonModal from 'components/common/CommonModal';
import DefaultButton from 'components/common/DefaultButton';
import DefaultImageView from 'components/common/DefaultImageView';
import DefaultText from 'components/common/DefaultText';
import LabelInput from 'components/common/LabelInput';
import {changePartnerCompanyName, changePaymentState} from 'function/api';
import React, {useEffect, useState} from 'react';
import {useRecoilValue} from 'recoil';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {userInfoState} from 'utils/Atoms';
import {minmax} from 'utils/minmax';

type Props = {
  selectItem: any;
  closeModal: () => void;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorModal: React.Dispatch<React.SetStateAction<{}>>;
};

const ChangePartnerCompanyNameModal = ({
  selectItem,
  closeModal,
  setIsLoading,
  setErrorModal,
}: Props) => {
  const userInfo = useRecoilValue(userInfoState);

  const [name, setName] = useState<string>('');

  const [confirmModal, setConfirmModal] = useState(false);
  const [completeModal, setCompleteModal] = useState(false);

  useEffect(() => {
    if (selectItem) {
      setName(selectItem?.name || '');
    }
  }, [selectItem]);

  return (
    <>
      <CommonModal closeModal={closeModal}>
        <BusinessModalContainer>
          <BusinessModalHeader>
            <DefaultText
              text="협력사명 변경"
              textStyle={{
                fontSize: minmax(40),
              }}
            />
            <DefaultImageView
              source="images/common/close.png"
              onClick={closeModal}
              style={{
                width: minmax(30),
                height: minmax(30),
                margin: minmax(15),
                cursor: 'pointer',
              }}
            />
          </BusinessModalHeader>

          <LabelInput
            type={'text'}
            labelText={'협력사명'}
            value={name}
            setValue={setName}
          />

          <DefaultButton
            text="change"
            actived={1}
            buttonStyle={{
              width: '100%',
              backgroundColor: colors.primary2,
            }}
            textStyle={{fontSize: minmax(25)}}
            onClick={() => {
              if (!name || !name.trim()) {
                setErrorModal({title: '입력 오류', detail: '협력사명을 입력해주세요.'});
                return;
              }
              setConfirmModal(true);
            }}
          />
        </BusinessModalContainer>
      </CommonModal>
      {confirmModal && (
        <CommonModal
          title="협력사명 변경 확인"
          detail={`협력사명을 "${name.trim()}"(으)로 변경하시겠습니까?`}
          firstButtonText="confirm"
          secondButtonText="cancel"
          firstButtonClick={async () => {
            setConfirmModal(false);
            const result = await changePartnerCompanyName({
              userInfo,
              setIsLoading,
              setErrorModal,
              partnerCompanyUUID: selectItem.uuid,
              name: name.trim(),
            });
            if (result) setCompleteModal(true);
          }}
          secondButtonClick={() => setConfirmModal(false)}
          closeModal={() => setConfirmModal(false)}
        />
      )}
      {completeModal && (
        <CommonModal
          title="협력사명 변경 완료!"
          detail="협력사명이 변경되었습니다."
          firstButtonText="confirm"
          firstButtonClick={() => {
            closeModal();
            window.location.reload();
          }}
        />
      )}
    </>
  );
};

export default ChangePartnerCompanyNameModal;

const BusinessModalContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: ${minmax(20)};
`;

const BusinessModalHeader = styled.div`
  width: 100%;
  margin-bottom: ${minmax(10)};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
`;
